import * as React from "react";
import { useEffect, useState } from "react";
import EYLogoAndHelpUrl from "../EYLogoAndHelpUrl";
import { Constants, EntityType, screenToRender } from "../../util/UIConstants";
import styled from "styled-components";
import _ = require("lodash");
import { labels, currentResource } from "../../util/utils";
import MotifButton from "@ey/motif-react-wrapper/Button";
import MotifSelect from "@ey/motif-react-wrapper/Select";
import MotifFormField from "@ey/motif-react-wrapper/FormField";
import MotifLabel from "@ey/motif-react-wrapper/Label";
import MotifOption from "@ey/motif-react-wrapper/Option";
import ProgressLoader from "./progressLoader";
import ErrorMessage from "./error/ErrorMessage";
import ErrorSummary from "./error/ErrorSummary";
import MotifErrorMessage from "@ey/motif-react-wrapper/ErrorMessage";
import { MotifIcon } from "@ey-xd/motif-react";
import { IconoirArrowLeft } from "@ey-xd/motif-icon";
import MotifCheckbox from "@ey/motif-react-wrapper/Checkbox";

function ClientRequestStatusSelectLayout(props: any) {
  const {
    inputObjectParameter,
    setStepToRender,
    onDataLoadClickMethod,
    errorMessage,
    resetErrorMessage,
    clientRequestStatus,
    setClientRequestStatus,
  } = props;
  const [loaderState, setLoaderState] = useState(false);
  const [isStatusSelected, setIsStatusSelected] = useState(true);

  const onDataLoadClick: React.MouseEventHandler<HTMLButtonElement> = async () => {
    if (_.isEmpty(clientRequestStatus)) {
      setIsStatusSelected(false);
      return;
    }

    let clientRequestSelectedStatus = clientRequestStatus
      .map((id) => {
        const option = currentResource.ClientRequestTypeOptions.find((option) => option.id === parseInt(id));
        return option ? option.apiPayload : null;
      })
      .filter((apiPayload) => apiPayload !== null) // Filter out null values
      .join("|");

    let InputObjectUrlDynamicParameter = { clientRequestSelectedStatus: clientRequestSelectedStatus };

    inputObjectParameter.current = InputObjectUrlDynamicParameter;

    onDataLoadClickMethod();
  };

  const updatingClientRequestStatusSelection = (id) => {
    setClientRequestStatus((prevStatus) =>
      prevStatus.includes(id) ? prevStatus.filter((statusId) => statusId !== id) : [...prevStatus, id]
    );
    setIsStatusSelected(true);
  };

  const getEngagementSelectionLayout = () => {
    return (
      <StyledEditClientRequest className="body-wrap edit-client-req">
        <section className="body-section">
          <EYLogoAndHelpUrl />
          <p className="informational-text motif-body1-default-light">{labels.editRequestMessage}</p>
          <MotifFormField>
            <MotifLabel title={labels.selectRequestStatus}>{labels.selectRequestStatus}</MotifLabel>
            {currentResource.ClientRequestTypeOptions.map((type) => {
              return (
                <MotifCheckbox
                  title = {type.label}
                  name={type.label}
                  key={type.label}
                  id={type.id}
                  checked={clientRequestStatus.includes(type.id)}
                  onChange={() => {
                    updatingClientRequestStatusSelection(type.id);
                  }}
                >
                  {type.label}
                </MotifCheckbox>
              );
            })}
          </MotifFormField>
          {!isStatusSelected && (
            <MotifErrorMessage id="select-error-reactive">{labels.selectRequestErrorMessage}</MotifErrorMessage>
          )}
        </section>
        <section className="footer-wrap">
          <MotifButton
            className="back-button"
            onClick={() => setStepToRender(screenToRender.EntitySelectLayout)}
            size="small"
            type="button"
            variant="secondary"
          >
            <MotifIcon src={IconoirArrowLeft} size="20" />
          </MotifButton>
          <MotifButton
            className={"btn active-btn"}
            onClick={(e) => onDataLoadClick(e)}
            size="small"
            type="submit"
            variant="primary-alt"
          >
            {labels.Continue}
          </MotifButton>
        </section>

        {errorMessage && (
          <ErrorSummary
            message={errorMessage}
            callBack={() => {
              resetErrorMessage();
            }}
          ></ErrorSummary>
        )}
      </StyledEditClientRequest>
    );
  };

  const renderContent = () => {
    if (loaderState) {
      return (
        <StyledMainSection className="main-wrap spinner-main">
          <section className="body-wrap">
            <EYLogoAndHelpUrl />
            <ProgressLoader show variant="default" />
          </section>
        </StyledMainSection>
      );
    }

    return <StyledMainSection className="main-wrap">{getEngagementSelectionLayout()}</StyledMainSection>;
  };

  return renderContent();
}

export default ClientRequestStatusSelectLayout;

const StyledMainSection = styled.section`
  height: 100%;
  &.spinner-main {
    background-color: var(--neutrals-900);
  }
  .body-wrap {
    position: relative;
    flex-flow: column;
    display: flex;
    background-color: var(--neutrals-50);
    height: 100vh;
    overflow: auto;
    justify-content: space-between;
    .error-wrapper {
      height: var(--px-22);
    }
    .breadcrumb-wrap {
      display: flex;
      align-items: center;
      a {
        color: var(--brand-500) !important;
        text-decoration: none;
      }
      .chevron-right-icon {
        display: flex;
        fill: var(--brand-500);
        width: var(--px-16);
        height: var(--px-16);
        margin: var(--px-3) var(--px-8) 0 var(--px-8);
        svg {
          width: 100%;
          height: 100%;
        }
      }
    }

    .ul-heading {
      margin-top: var(--px-14) !important;
    }
    .unordered-list {
      padding: 0 0 0 var(--px-4);
      margin-bottom: var(--px-35);
      li {
        margin: 0;
        padding: 0;
        display: flex;
        align-items: flex-start;
        list-style: none;
        font-size: var(--px-12);
        font-weight: 300;
        margin-bottom: var(--px-10);
        svg {
          width: var(--px-10);
          height: var(--px-10);
          fill: var(--neutrals-900);
          margin-right: var(--px-5);
          margin-top: var(--px-3);
        }
        span {
          display: inline-block;
          width: calc(100% - var(--px-15));
        }
      }
    }
    .informational-text {
      margin: 0;
      color: var(--neutrals-900);
      font-size: var(--px-12);
      margin-bottom: var(--px-12);
    }
    .submit-text {
      font-weight: 400;
    }

    .informational-text2 {
      margin-top: var(--px-15);
      color: var(--neutrals-900);
    }

    .motif-label{
      font-size: var(--px-12);
    }
    /* .motif-select-search-input {
      font-size: var(--px-12);
    } */

    .eng-label {
      /* font-size: var(--px-12);
      font-weight: 400; */
      margin-bottom: var(--px-8);
    }

    .input-field {
      border-radius: var(--px-4);
      padding: var(--px-8) var(--px-5);
      border: 0;
      margin-bottom: var(--px-10);
      &:focus {
        outline: none;
      }
    }

    .btn {
      &.secondary-btn {
        width: 30%;
        &:hover {
          cursor: pointer;
        }
      }
      &.back-btn {
        margin-top: auto;
      }
    }

    &.edit-doc-wrap {
      .select-option-wrap {
        span {
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          width: 100%;
          display: inline-block;
          font-size: var(--px-12);
        }
      }
    }
    .progress-bar {
      height: var(--px-10);
      background-color: #0d6f2f;
      overflow: hidden;
    }
    .body-section {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding: var(--spacing-medium) var(--spacing-x-large) var(--spacing-x-large) var(--spacing-x-large);
      .informational-text {
        color: var(--neutrals-900);
        font-size: var(--px-12);
      }
      .motif-form-field{
        .motif-label{
          margin-bottom: var(--spacing-medium);
        }
      }

      .motif-checkbox-wrapper{
        margin-bottom: var(--spacing-large);
        &:last-child{
          margin-bottom: 0;
        }
      }
    }
    .footer-wrap {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      padding: var(--spacing-large) var(--spacing-xx-large);
      border-top: 1px solid var(--neutrals-100);
      gap: var(--px-16);
      .back-button {
        padding: var(--px-5) !important;
        .motif-icon {
          display: flex;
          height: var(--px-20);
          width: var(--px-20);
        }
      }
    }
  }
  .motif-select-input-text {
    font-size: var(--px-12);
  }
`;
const StyledEditClientRequest = styled.section`
  .motif-checkbox-label{
    font-size: var(--px-12);
  }
`;
